import React from 'react';

function Image({ imgSrc, imgAlt, imgClass, ...otherProps }) {
    return (
        <img src={imgSrc} alt={imgAlt} className={`imgComp ${imgClass}`} {...otherProps} loading="lazy" draggable={false} />
    );
}

export default Image;
